// src/hooks/useDeleteProduct.js
import { useState } from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firestore instance

const useDeleteProduct = () => {
  const [isPending, setIsPending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  /**
   * Deletes a product from a specific list in Firestore.
   * @param {string} listId The ID of the list the product belongs to.
   * @param {string} productId The ID of the product to delete.
   */
  const deleteProduct = async (listId, productId) => {
    setIsPending(true);
    setIsError(false);
    setIsSuccess(false);

    try {
      if (!listId || !productId) {
        throw new Error(
          "Both listId and productId are required to delete a product."
        );
      }

      const productRef = doc(db, "lists", listId, "products", productId);
      await deleteDoc(productRef);

      setIsSuccess(true);
      console.log(
        `Product ${productId} deleted successfully from list ${listId}.`
      );
    } catch (error) {
      setIsError(true);
      console.error("Error deleting product:", error);
      // You might want to re-throw or return the error for caller to handle specific messages
      throw error; // Re-throw to allow component to catch if needed
    } finally {
      setIsPending(false);
    }
  };

  // Reset status flags after an operation might be useful if you reuse the hook instance
  const resetStatus = () => {
    setIsPending(false);
    setIsError(false);
    setIsSuccess(false);
  };

  return { deleteProduct, isPending, isError, isSuccess, resetStatus };
};

export default useDeleteProduct;
